import { DatastoreInterface } from '@freelancer/datastore/core';
import { RoleApi } from 'api-typings/common/common';
import {
  CurrencyCode,
  generateCurrencyObject,
} from '../currencies/currencies.mock';
import { generateUserObject, GenerateUserOptions } from '../users/users.mock';
import { UsersSelf } from './users-self.model';
import { UsersSelfCollection } from './users-self.types';

export async function createUserSelf(
  datastore: DatastoreInterface,
  options: GenerateUserOptions,
) {
  const object = createUserSelfObject(options);
  await datastore.createDocument<UsersSelfCollection>('usersSelf', object);
  return object;
}

function createUserSelfObject({
  userId,
  username = 'testUsername',
  displayName = 'Test Name',
  role = RoleApi.EMPLOYER,
  chosenRole,
  currencyCode = CurrencyCode.USD,
  userStatus = {
    paymentVerified: true,
    emailVerified: true,
    depositMade: true,
    profileComplete: true,
    phoneVerified: true,
    identityVerified: false,
    facebookConnected: false,
  },
}: GenerateUserOptions = {}): UsersSelf {
  return {
    ...generateUserObject({
      userId,
      username,
      displayName,
      role,
      chosenRole,
      currencyCode,
      userStatus,
    }),
    primaryCurrency: generateCurrencyObject(currencyCode),
    hasLinkedEscrowComAccount: false,
    profileCompleted: true,
    escrowProfileCompleted: false,
  };
}
